$(document).on("turbolinks:load", function () {

  if ( $('#js-take-payments-client-select').is('*')) {
    setLiveSearch();
    setClientListBindings();

    $('#js-take-payments-client-select').on('change', function(){
      getInvoiceList();
    });
  }

});

function setLiveSearch() {
  $('#js-take-payments-client-select')
    .selectpicker()
    .ajaxSelectPicker({
      ajax: {
        url: "/business/search/client",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "X-CSRF-Token",
            localStorage.getItem("bp-x-csrf-token")
          );
        },
        data: function () {
          var params = {
            q: "{{{q}}}",
          };
          return params;
        },
      },
      clearOnEmpty: false,
      emptyRequest: true,
      cache: false,
      preserveSelected: false,
    });
}

function setClientListBindings() {
  $('#js-client-list li').on('click', function(){
    var clientId = $(this).data('client');

    $('#js-invoice-list, #js-new-client-form, #js-error').hide();
    $('#js-loading').show();

    $('#js-client-list li label').removeClass('active');
    $(this).find('label').addClass('active');
    
    if (clientId == 'new') {
      $('#js-loading').hide();
      $('#js-new-client-form').show();

    } else if (clientId != 'search') {
      getInvoiceList(clientId);
    }
  });
}

function getInvoiceList(clientId) {
  $.ajax({
    url: $('#js-invoice-list').data('url'),
    type: 'GET',
    beforeSend: function (xhr) {
      xhr.setRequestHeader(
        "X-CSRF-Token",
        localStorage.getItem("bp-x-csrf-token")
      );
    },
    data: {
      client_id: clientId
    },
    dataType: "script",
    error: () => {
      $('#js-loading').hide();
      $('#js-error').show();
      
      window.notyf.error(
        "We encountered an error retrieving this client's invoices."
      );
    }

  });

}
